// extracted by mini-css-extract-plugin
export default {"container":"PageTitle_container__GRvgH","iconContainer":"PageTitle_iconContainer__q4YtV","userName":"PageTitle_userName__Prz3v"};